import { render, staticRenderFns } from "./Trash.vue?vue&type=template&id=5ba12f7f&scoped=true&"
import script from "./Trash.vue?vue&type=script&lang=js&"
export * from "./Trash.vue?vue&type=script&lang=js&"
import style0 from "./Trash.vue?vue&type=style&index=0&id=5ba12f7f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba12f7f",
  null
  
)

export default component.exports